import { saveAs } from "file-saver";
import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import ReactJson from "react-json-view";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

export default class N18odit extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;
        this.Report = this.Report.bind(this);
        this.Results = this.Results.bind(this);
        this.state = { CanQuery: false };
    }

    componentDidMount() {
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
        };
        var dates = Comm.CallServerFunction("n18_odit/date_range", data);
        this.MinDate = moment(dates.date_range.min, "YYYY-MM-DD");
        this.MaxDate = moment(dates.date_range.max, "YYYY-MM-DD");
        data.from = this.MinDate.format("YYYYMMDD");
        data.to = this.MaxDate.format("YYYYMMDD");
        var shops = Comm.CallServerFunction("n18_odit/shop_ids_by_date_range", data).shops;
        var devices = Comm.CallServerFunction("n18_odit/fisc_devices_by_date_range", data).devices;
        var workplaces = Comm.CallServerFunction("n18_odit/workplaces_by_date_range", data).workplaces;
        var operators = Comm.CallServerFunction("n18_odit/operators_by_date_range", data).operators;
        this.setState({
            FromDate: this.MinDate,
            ToDate: this.MaxDate,
            Shops: shops,
            Devices: devices,
            Workplaces: workplaces,
            Opertors: operators,
            ReportId: 1,
            Rows: [],
            CanQuery: true,
        });
    }

    Report() {
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from: this.state.FromDate.format("YYYYMMDD"),
            to: this.state.ToDate.format("YYYYMMDD"),
        };

        if ((this.state.ShopId || "") !== "") data.shop_id = this.state.ShopId;
        if ((this.state.DeviceId || "") !== "") data.fisc_device = this.state.DeviceId;
        if ((this.state.WorkplaceId || "") !== "") data.workingplace = this.state.WorkplaceId;
        if ((this.state.OperatorId || "") !== "") data.operator_id = this.state.OperatorId;

        var rows = [];
        console.log("data", data);
        switch (parseInt(this.state.ReportId, 10)) {
            case 1:
                rows = Comm.CallServerFunction("n18_odit/payments_general_data", data).data || [];
                break;
            case 2:
                rows = Comm.CallServerFunction("n18_odit/payments_by_sells", data).data || [];
                break;
            case 3:
                rows = Comm.CallServerFunction("n18_odit/payments_detailed_data", data).data || [];
                break;
            case 4:
                rows = Comm.CallServerFunction("n18_odit/storno_data", data).data || [];
                break;
            case 5:
                console.log("cancel", Comm.CallServerFunction("n18_odit/canceled_data", data));
                rows = Comm.CallServerFunction("n18_odit/canceled_data", data).data || [];
                break;
            case 6:
                rows = Comm.CallServerFunction("n18_odit/deliveries_base", data).data || [];
                break;
            case 7:
                rows = Comm.CallServerFunction("n18_odit/delivery_details", data).data || [];
                break;
            case 98:
                rows = Comm.CallServerFunction("n18_odit/user_changes", data).data || [];
                break;
            case 981:
                rows = Comm.CallServerFunction("n18_odit/operators_sell_login_logout", data).result || [];
                break;
            case 982:
                rows = Comm.CallServerFunction("n18_odit/storno_operations", data).result || [];
                break;
            default:
                break;
        }
        console.log("Rows", rows);
        this.setState({ Rows: rows });
    }

    CSV() {
        var csv = "";

        csv +=
            $("#tResults thead tr th")
                .toArray()
                .map((x) => '"' + (x.innerText || "") + '"')
                .join(",") + "\n";
        $("#tResults tbody tr")
            .toArray()
            .forEach(
                (x) =>
                    (csv +=
                        $(x)
                            .children()
                            .toArray()
                            .map((x) => '"' + (x.innerText || "") + '"')
                            .join(",") + "\n")
            );

        var file = new Blob([csv], { type: "text/plain;charset=utf-8" });
        saveAs(file, "report.csv");
    }

    Results() {
        if (this.state.Rows.length === 0) return null;
        if (this.state.ReportId == 1) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("uniquenumber")} </th>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("shop")} </th>
                                <th>{Translation.Trans("fromdate")} </th>
                                <th>{Translation.Trans("fromtime")} </th>
                                <th>{Translation.Trans("workplace")} </th>
                                <th>{Translation.Trans("operatorcode")} </th>
                                <th>{Translation.Trans("neto")} </th>
                                <th>{Translation.Trans("discount")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("sum")} </th>
                                <th>{Translation.Trans("invoice")} </th>
                                <th>{Translation.Trans("invoicedate")} </th>
                                <th>{Translation.Trans("todate")} </th>
                                <th>{Translation.Trans("totime")} </th>
                                <th>{Translation.Trans("partner")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.unique_nom}</td>
                                    <td>{x.id}</td>
                                    <td>{x.shop_name}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.start_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.start_time}</td>
                                    <td>{x.workplace_code}</td>
                                    <td>{x.operator_code}</td>
                                    <td>{x.neto}</td>
                                    <td>{x.discount}</td>
                                    <td>{x.dds}</td>
                                    <td>{x.sum}</td>
                                    <td>{x.invoice_no}</td>
                                    <td>{x.invoice_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.end_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.end_time}</td>
                                    <td>{x.partner_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 2) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("uniquenumber")} </th>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("fromdate")} </th>
                                <th>{Translation.Trans("fromtime")} </th>
                                <th>{Translation.Trans("todate")} </th>
                                <th>{Translation.Trans("totime")} </th>
                                <th>{Translation.Trans("sum")} </th>
                                <th>{Translation.Trans("paymentdate")} </th>
                                <th>{Translation.Trans("operatorcode")} </th>
                                <th>{Translation.Trans("neto")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("paymenttype")} </th>
                                <th>{Translation.Trans("device")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.unique_nom}</td>
                                    <td>{x.id}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.start_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.start_time}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.end_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.end_time}</td>
                                    <td>{x.sum}</td>
                                    <td>{moment(x.payment_date).format("DD-MM-YYYY hh:mm")}</td>
                                    <td>{x.operator_code}</td>
                                    <td>{x.neto}</td>
                                    <td>{x.dds}</td>
                                    <td>{x.payment_type}</td>
                                    <td>{x.dev_id}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 3) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("uniquenumber")} </th>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("articlecode")} </th>
                                <th>{Translation.Trans("article")} </th>
                                <th>{Translation.Trans("quantity")} </th>
                                <th>{Translation.Trans("price")} </th>
                                <th>{Translation.Trans("discount")} </th>
                                <th>{Translation.Trans("vatsize")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("sum")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.unique_nom}</td>
                                    <td>{x.id}</td>
                                    <td>{x.article_code}</td>
                                    <td>{x.article}</td>
                                    <td>{x.qty}</td>
                                    <td>{x.price}</td>
                                    <td>{x.discount}</td>
                                    <td>{x.dds_perc}%</td>
                                    <td>{x.dds}</td>
                                    <td>{x.sum}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 4) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("uniquenumber")} </th>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("articlecode")} </th>
                                <th>{Translation.Trans("article")} </th>
                                <th>{Translation.Trans("quantity")} </th>
                                <th>{Translation.Trans("price")} </th>
                                <th>{Translation.Trans("discount")} </th>
                                <th>{Translation.Trans("vatsize")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("sum")} </th>
                                <th>{Translation.Trans("saleenddate")} </th>
                                <th>{Translation.Trans("saleendtime")} </th>
                                <th>{Translation.Trans("stornodate")} </th>
                                <th>{Translation.Trans("stornotime")} </th>
                                <th>{Translation.Trans("device")} </th>
                                <th>{Translation.Trans("operator")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.unique_nom}</td>
                                    <td>{x.id}</td>
                                    <td>{x.article_code}</td>
                                    <td>{x.article}</td>
                                    <td>{x.qty}</td>
                                    <td>{x.price}</td>
                                    <td>{x.discount}</td>
                                    <td>{x.dds_perc}</td>
                                    <td>{x.dds}</td>
                                    <td>{x.sum}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.sell_end_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.sell_end_time}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.storno_date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.storno_time}</td>
                                    <td>{x.device_id}</td>
                                    <td>{x.storno_operator}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 5) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("uniquenumber")} </th>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("canceledcode")} </th>
                                <th>{Translation.Trans("article")} </th>
                                <th>{Translation.Trans("quantity")} </th>
                                <th>{Translation.Trans("singleprice")} </th>
                                <th>{Translation.Trans("discount")} </th>
                                <th>{Translation.Trans("vatsize")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("sum")} </th>
                                <th>{Translation.Trans("opendate")} </th>
                                <th>{Translation.Trans("opentime")} </th>
                                <th>{Translation.Trans("canceldate")} </th>
                                <th>{Translation.Trans("canceltime")} </th>
                                <th>{Translation.Trans("operator")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.unp}</td>
                                    <td>{x.id}</td>
                                    <td>{x.code}</td>
                                    <td>{x.name}</td>
                                    <td>{x.qty}</td>
                                    <td>{x.price}</td>
                                    <td>{x.discount}</td>
                                    <td>{x.dds}</td>
                                    <td>{x.dds_sum}</td>
                                    <td>{x.sum}</td>
                                    <td>{x.dt}</td>
                                    <td>{x.h}</td>
                                    <td>{x.cor_dt}</td>
                                    <td>{x.cor_h}</td>

                                    <td>{x.username}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 6) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("date")} </th>
                                <th>{Translation.Trans("time")} </th>
                                <th>{Translation.Trans("operatorcode")} </th>
                                <th>{Translation.Trans("deliverercode")} </th>
                                <th>{Translation.Trans("deliverer")} </th>
                                <th>{Translation.Trans("invoice")} </th>
                                <th>{Translation.Trans("invoicedate")} </th>
                                <th>{Translation.Trans("neto")} </th>
                                <th>{Translation.Trans("discount")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("sum")} </th>

                                <th>{Translation.Trans("paymenttype")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.id}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.date}</td>
                                    <td style={{ "white-space": "nowrap" }}>{x.time}</td>
                                    <td>{x.operator_code}</td>
                                    <td>{x.partner_code}</td>
                                    <td>{x.partner_name}</td>
                                    <td>{x.invoice_no}</td>
                                    <td>{x.invoice_date}</td>
                                    <td>{x.neto}</td>
                                    <td>{x.discount}</td>
                                    <td>{x.dds}</td>
                                    <td>{x.sum}</td>
                                    <td>{x.payment_type}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 7) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("systemnumber")} </th>
                                <th>{Translation.Trans("articlecode")} </th>
                                <th>{Translation.Trans("article")} </th>
                                <th>{Translation.Trans("quantity")} </th>
                                <th>{Translation.Trans("price")} </th>
                                <th>{Translation.Trans("discount")} </th>
                                <th>{Translation.Trans("vatamount")} </th>
                                <th>{Translation.Trans("sum_lv")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.id}</td>
                                    <td>{x.code}</td>
                                    <td>{x.name}</td>
                                    <td>{x.qty}</td>
                                    <td>{x.price}</td>
                                    <td>{x.discount}</td>
                                    <td>{x.dds}</td>
                                    <td>{x.sum_lv}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 98) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <ReactJson
                        src={this.state.Rows}
                        enableClipboard={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                    />
                </div>
            );
        }

        if (this.state.ReportId == 981) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("shop")} </th>
                                <th>{Translation.Trans("moment")} </th>
                                <th>{Translation.Trans("operation")} </th>
                                <th>{Translation.Trans("operatorcode")} </th>
                                <th>{Translation.Trans("username")} </th>
                                <th>{Translation.Trans("name")} </th>
                                <th>{Translation.Trans("surname")} </th>
                                <th>{Translation.Trans("family")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{x.shop}</td>
                                    <td>{moment(x.moment).format("DD.MM.YYYY hh:mm")}</td>
                                    <td>{x.operation}</td>
                                    <td>{x.operator_code}</td>
                                    <td>{x.operator_login}</td>
                                    <td>{x.operator_name_1}</td>
                                    <td>{x.operator_name_2}</td>
                                    <td>{x.operator_name_3}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        if (this.state.ReportId == 982) {
            return (
                <div style={{ "overflow-x": "auto" }}>
                    <table className="table table-borered table-striped" id="tResults">
                        <thead>
                            <tr>
                                <th>{Translation.Trans("moment")} </th>
                                <th>{Translation.Trans("uniquenumber")} </th>
                                <th>{Translation.Trans("username")} </th>
                                <th>{Translation.Trans("name")} </th>
                                <th>{Translation.Trans("surname")} </th>
                                <th>{Translation.Trans("family")} </th>
                                <th>{Translation.Trans("operation")} </th>
                                <th>{Translation.Trans("operatorcode")} </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Rows.map((x) => (
                                <tr>
                                    <td>{moment(x.dt).format("DD.MM.YYYY hh:mm")}</td>
                                    <td>{x.unp}</td>
                                    <td>{x.name}</td>
                                    <td>{x.name1}</td>
                                    <td>{x.name2}</td>
                                    <td>{x.name3}</td>
                                    <td>{x.operation}</td>
                                    <td>{x.operator_code}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        return <div></div>;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        var self = this;
        return (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("n18odit")}</div>
                <div className="panel-body">
                    {this.state.CanQuery
                        ? [
                              <div className="row">
                                  <div className="col-md-3">
                                      <label className="control-label">{Translation.Trans("FromDate")}</label>
                                      <Datetime
                                          inputProps={{
                                              placeholder: "N/A",
                                              readOnly: "true",
                                              className: "form-control pointhand",
                                          }}
                                          dateFormat="DD.MM.YYYY"
                                          timeFormat=""
                                          onChange={(e) =>
                                              this.setState({
                                                  FromDate: moment.max([e, this.MinDate]),
                                                  Rows: [],
                                              })
                                          }
                                          value={this.state.FromDate}
                                          closeOnSelect="true"
                                      ></Datetime>
                                  </div>
                                  <div className="col-md-3">
                                      <label className="control-label">{Translation.Trans("ToDate")}</label>
                                      <Datetime
                                          inputProps={{
                                              placeholder: "N/A",
                                              readOnly: "true",
                                              className: "form-control pointhand",
                                          }}
                                          dateFormat="DD.MM.YYYY"
                                          timeFormat=""
                                          onChange={(e) =>
                                              this.setState({
                                                  ToDate:
                                                      [981, 10, 5].indexOf(
                                                          parseInt(self.state.ReportId, 10)
                                                      ) > -1
                                                          ? e
                                                          : moment.min([e, this.MaxDate]),
                                                  Rows: [],
                                              })
                                          }
                                          value={this.state.ToDate}
                                          closeOnSelect="true"
                                      ></Datetime>
                                  </div>
                                  <div className="col-md-3">
                                      <label className="control-label">{Translation.Trans("operator")}</label>
                                      <select
                                          className="form-control"
                                          value={self.state.OperatorId}
                                          onChange={(e) =>
                                              self.setState({ OperatorId: e.target.value, Rows: [] })
                                          }
                                      >
                                          <option></option>
                                          {self.state.Opertors.map((x) => (
                                              <option value={x.operator_id}>{x.operator_name}</option>
                                          ))}
                                      </select>
                                  </div>
                                  <div className="col-md-3">
                                      <label className="control-label">{Translation.Trans("shop")}</label>
                                      <select
                                          className="form-control"
                                          value={self.state.ShopId}
                                          onChange={(e) =>
                                              self.setState({ ShopId: e.target.value, Rows: [] })
                                          }
                                      >
                                          <option></option>
                                          {self.state.Shops.map((x) => (
                                              <option value={x.shop_id}>{x.name}</option>
                                          ))}
                                      </select>
                                  </div>
                              </div>,
                              <div className="row">
                                  <div className="col-md-3">
                                      <label className="control-label">{Translation.Trans("device")}</label>
                                      <select
                                          className="form-control"
                                          value={self.state.DeviceId}
                                          onChange={(e) =>
                                              self.setState({ DeviceId: e.target.value, Rows: [] })
                                          }
                                      >
                                          <option></option>
                                          {self.state.Devices.map((x) => (
                                              <option value={x.device_id}>{x.device_id}</option>
                                          ))}
                                      </select>
                                  </div>
                                  <div className="col-md-3">
                                      <label className="control-label">
                                          {Translation.Trans("workplace")}
                                      </label>
                                      <select
                                          className="form-control"
                                          value={self.state.WorkplaceId}
                                          onChange={(e) =>
                                              self.setState({ WorkplaceId: e.target.value, Rows: [] })
                                          }
                                      >
                                          <option></option>
                                          {self.state.Workplaces.map((x) => (
                                              <option value={x.workingplace}>
                                                  {x.name} {x.workingplace}
                                              </option>
                                          ))}
                                      </select>
                                  </div>
                                  <div className="col-md-3">
                                      <label className="control-label">{Translation.Trans("report")}</label>
                                      <select
                                          className="form-control"
                                          value={self.state.ReportId}
                                          onChange={(e) =>
                                              self.setState({ ReportId: e.target.value, Rows: [] })
                                          }
                                      >
                                          <option value="1">{Translation.Trans("n18r1")}</option>
                                          <option value="2">{Translation.Trans("n18r2")}</option>
                                          <option value="3">{Translation.Trans("n18r3")}</option>
                                          <option value="4">{Translation.Trans("n18r4")}</option>
                                          <option value="6">{Translation.Trans("n18r6")}</option>
                                          <option value="5">{Translation.Trans("n18r5")}</option>
                                          <option value="7">{Translation.Trans("n18r7")}</option>
                                          <option value="98">{Translation.Trans("n18r98")}</option>
                                          <option value="981">{Translation.Trans("n18r981")}</option>
                                          <option value="982">{Translation.Trans("n18r982")}</option>
                                      </select>
                                  </div>
                                  <div className="col-md-3">
                                      <button className="btn btn-primary pull-right" onClick={self.Report}>
                                          {Translation.Trans("report")}
                                      </button>
                                  </div>
                              </div>,
                              <div className="row">
                                  <div className="col-md-12">
                                      {self.Results()}
                                      {self.state.Rows.length > 0 ? (
                                          <button className="btn btn-primary pull-right" onClick={self.CSV}>
                                              {Translation.Trans("csv")}
                                          </button>
                                      ) : null}
                                  </div>
                              </div>,
                          ]
                        : null}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/n18odit.js